<template>
    <div class="map-viewer">
        <div class="map-left-panel">
            <div class=" map-viewer-operate">
                <div class="map-title-panel">
                    <p class="map-title-panel-text" v-show="!editTtle" @click="exitEdit">
                        {{ mapTitle }}
                    </p>

                    <a href="#" target="_blank">
                        <span class="map-title-panel-browse icon-icomoon-shapeditu" title="浏览地图"></span>
                    </a>

                    <span class="map-title-panel-lock icon-icomoon-morensuodingshiye" title="锁定默认视图"></span>



                </div>
                <div>
                    <LayerManager />
                </div>
            </div>
        </div>

        <div class="map-right-panel">
            <MapView />
        </div>

        <div class="map-tools-panel">
            <ViewerTools />
        </div>
    </div>
</template>

<script>
import MapView from '@/components/common/MapView.vue';
import ViewerTools from '@/components/common/ViewerTools.vue';
import LayerManager from "@/components/content/LayerManager.vue";
import { useMapStore } from '@/stores/mapStore';


import { useRouter, useRoute } from 'vue-router';

export default {
    name: 'MapViewer',
    components: {
        MapView,
        ViewerTools,
        LayerManager
    },
    data() {
        return {
            mapTitle: '',
            mapStore: null,
            router: null
        }
    },
    mounted() {
        this.router = useRouter();

        const customParam = localStorage.getItem('token');
        if (!customParam) {
            this.router.push({ path: '/login' });
        }
        this.mapStore = useMapStore();
        if (this.mapStore.getSelectAtlas()) {
            this.mapTitle = this.mapStore.getSelectAtlas().name;
        }
    },
    methods: {
        exitEdit() {
            this.router.push({ path: '/map/list' });
        }
    }
}
</script>

<style scoped>
@import url('@/assets/css/mapViewer.css');

.map-viewer {
    position: relative;
    height: 100%;
    width: 100%;
}

.map-title-panel-text {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 13px;
    margin-top: 1px;
    font-size: 16px;
    width: 200px;
    cursor: pointer;
    float: left !important;
    color: #000;
}

.map-title-panel-lock {
    float: right !important;
    margin-right: 16px;
    color: #fff;
    font-size: 14px;
    margin-top: 16px;
    cursor: pointer;
}

.map-left-panel {
    position: relative;
    min-width: 40px;
    height: inherit;
    float: left;

    display: flex;
    /* 设置为 Flex 容器 */
    flex-wrap: nowrap;
    /* 不换行 */
}

.map-title-edit-panel {
    position: absolute;
    width: 200px;
    top: 6px;
}

.map-viewer-operate {
    position: relative;
    width: 300px;
    height: inherit;
    padding: 8px;
    float: left;
}

.map-right-panel {
    position: relative;
    height: 100%;
    overflow: hidden;
}

.map-title-panel-browse {
    color: #fff;
    font-size: 14px;
    margin-top: 16px;
    margin-right: 10px;
    float: right !important;
}

.map-title-panel {
    background-color: #ffffff;
    height: 46px;
    line-height: 46px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    margin-left: -10px;
    margin-top: -8px;
    margin-right: -10px;
    margin-bottom: 8px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 100;
    color: #000;

}

.map-tools-panel {
    position: absolute;
    right: 10px;
    top: 13px;
    z-index: 1000;
}

.map-title-edit-save {
    top: 10px;
    right: 8px;
    color: #567d8b;
    margin: 0;
    font-size: 14px;
    position: absolute;
    cursor: pointer;
}

.map-title-edit-input {
    padding-right: 24px !important;
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555555;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
</style>